<template>
   <v-app>
        <header-card-public current_page="notfoundpage"></header-card-public>
        <v-content class="bg">
            <v-layout fill-height align-center row wrap >     
                <v-flex xs12 >
                    <div class="text-xs-center">
                        <h1 class="display-1 white--text">The page you are trying to access does not exist.</h1><br><br>
                        <v-btn @click="$router.go(-1)">Back to previous page</v-btn>
                    </div>
                </v-flex>
            </v-layout>
       </v-content>
   </v-app>
</template>
<script>

import '@/assets/css/public.css'

export default {
    components: {
        'header-card-public': () => import('@/components/Common/HeaderPublic'),
        'footer-card': () => import('@/components/Common/Footer')
    },
    data() {
        return {}
    },
    methods: {}
}
</script>